module.exports = __webpack_public_path__ + "static/media/highlightdont.0b2d5ad6.png";